import { render, staticRenderFns } from "./NoOrganizationOverlay.vue?vue&type=template&id=635a008d&scoped=true"
import script from "./NoOrganizationOverlay.vue?vue&type=script&lang=js"
export * from "./NoOrganizationOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635a008d",
  null
  
)

export default component.exports